import { render } from "./OrderCheck.vue?vue&type=template&id=cd1f5d16&scoped=true"
import script from "./OrderCheck.vue?vue&type=script&lang=js"
export * from "./OrderCheck.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=cd1f5d16&scoped=true&lang=css"
import "@/assets/css/user/pages/payment.css?vue&type=style&index=1&id=cd1f5d16&scoped=true&lang=css"
import "@/assets/css/user/pages/touchbox.css?vue&type=style&index=2&id=cd1f5d16&scoped=true&lang=css"
import "@/assets/css/user/pages/table.css?vue&type=style&index=3&id=cd1f5d16&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=4&id=cd1f5d16&scoped=true&lang=css"
import "@/assets/css/user/dark/payment-dark.css?vue&type=style&index=5&id=cd1f5d16&scoped=true&lang=css"
import "@/assets/css/user/dark/touchbox-dark.css?vue&type=style&index=6&id=cd1f5d16&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd1f5d16"]])

export default __exports__